import { firstNameSchemaV4, lastNameSchemaV4 } from '@massilia/features'
import { isBefore, startOfDay } from 'date-fns'
import { z } from 'zod/v4'

export const reservationPassengerSchema = z.object({
  firstName: firstNameSchemaV4,
  lastName: lastNameSchemaV4,
  passengerId: z.string(),
  birthDate: z.string(),
  fidelityCards: z
    .array(
      z.object({
        id: z.string().optional(),
        cardNumber: z.string(),
        /** Stored as an Option ({ label, value }) for autocomplete. value = companyId. */
        company: z.object({ label: z.string(), value: z.string() }),
      })
    )
    .optional(),
  gender: z.enum(['MALE', 'FEMALE']),
  identityDocuments: z
    .array(
      z
        .object({
          id: z.string().optional(),
          documentNumber: z.string(),
          expiryDate: z.string().min(1, "Date d'expiration requise"),
          issuingCountry: z.object({ label: z.string(), value: z.string() }),
          type: z.enum(['PASSPORT', 'CNI']),
        })
        .check((ctx) => {
          if (
            ctx.value.expiryDate &&
            isBefore(new Date(ctx.value.expiryDate), startOfDay(new Date()))
          ) {
            ctx.issues.push({
              code: 'custom',
              input: ctx.value,
              message: "Le document d'identité est expiré",
              path: ['expiryDate'],
            })
          }
        })
    )
    .optional(),
  nationality: z.string().min(1, 'Nationalité requise'),
})

export const reservationSchema = z.object({
  acceptsTermsAndConditions: z
    .boolean()
    .refine(
      (value) => value === true,
      'Vous devez accepter les conditions générales pour continuer'
    ),
  animalInformation: z.string(),
  complementaryInformation: z.string(),
  newsletterSubscription: z.enum(['YES', 'NO', 'ALREADY_SUBSCRIBED']),
  otherContactPhone: z.string().optional().or(z.literal('')),
  otherEmailAddress: z.email().optional().or(z.literal('')),
  passengers: z.array(reservationPassengerSchema).min(1),
  seatInformation: z.string(),
  wantsCarLoan: z.boolean(),
  wantsInsurance: z.boolean(),
  wantsInvoice: z.boolean(),
})

export type ReservationPassengerSchema = z.infer<typeof reservationPassengerSchema>
export type ReservationSchema = z.infer<typeof reservationSchema>
